export default {
      id: "play-usage",
      viewBox: "0 0 485 485",
      url: __webpack_public_path__ + "img/icons.svg?fe1823f2d070fe6b8364c4176dd9a880#play",
      toString: function () {
        return this.url;
      }
    }